<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 v-if="organizationUnitId" :tid="organizationUnitId"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage user's details</h1>

                    <a :href="`/#/admin/organizations/users/manage/${id}`" class="btn btn-link btn-sm">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        <span>Back</span>
                    </a>
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <h3 class="fg-color-blue">User {{email}}</h3>
            <br />

            <div class="form-group">
                <label for="FirstName">First name:</label>
                <input v-model="inputFirstName" type="text" class="form-control" placeholder="First name of an user">
                <ValidationError context="FirstName" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="LastName">Last name:</label>
                <input v-model="inputLastName" type="text" class="form-control" placeholder="Last name of an user">
                <ValidationError context="LastName" :errors="validationErrors"></ValidationError>
            </div>

            <div class="form-group">
                <label for="DisplayName">Display name:</label>
                <input v-model="inputDisplayName" type="text" class="form-control" placeholder="Display name of an user">
                <ValidationError context="DisplayName" :errors="validationErrors"></ValidationError>
            </div>

            <button v-show="statusInitial || statusInvalid" @click="handleUpdateUserDetailsCommandV1" type="button" class="btn btn-primary btn-lg">Update</button>
            <button v-show="statusInvoking" type="button" class="btn btn-primary btn-lg" disabled>Updating...</button>
        </div>
    </div>
</template>

<script lang="ts">
    import Component, { mixins } from 'vue-class-component';
    import PageBase from "@common/PageBase";
    import PageStatus from "@common/PageStatus";
    import Queries from "@Organizations/Users/Domain/queries-vue-component";
    import Commands from "@Organizations/Users/Domain/commands-vue-component";
    import "@common/AdminNavigationV2.vue";

    @Component({
        watch: {
            userWithSensitiveData: 'userWithSensitiveDataChanged'
        }
    })
    export default class ManageUserDetailsPage extends mixins(PageBase, PageStatus, Queries, Commands) {
        inputFirstName = '';
        inputLastName = '';
        inputDisplayName = '';

        mounted() {
            this.setTitle("Manage user's details");
            this.runCurrentUserQueryV1(false, true, false);
            this.runUserQueryV1(this.id);
        }

        get userSessionDetails() { return this.model?.UserSessionDetails; }
        get userWithSensitiveData() { return this.model?.UserWithSensitiveData; }

        get user() { return this.userWithSensitiveData; }
        get email() { return this.user?.Email; }
        get firstName() { return this.user?.FirstName; }
        get lastName() { return this.user?.LastName; }
        get displayName() { return this.user?.DisplayName; }
        get organizationUnitId() { return this.user?.OrganizationUnitId; }

        //@Watch('userWithSensitiveData')
        userWithSensitiveDataChanged(userWithSensitiveData) {
            if (userWithSensitiveData) {
                this.inputFirstName = userWithSensitiveData.FirstName;
                this.inputLastName = userWithSensitiveData.LastName;
                this.inputDisplayName = userWithSensitiveData.DisplayName;
            }
        }

        handleUpdateUserDetailsCommandV1() {
            this.invokeUpdateUserDetailsCommandV1(this.id, this.inputFirstName, this.inputLastName, this.inputDisplayName);
        }

        succeedUpdateUserDetailsCommandV1(status) {
            this.setStatusSucceed();
            this.$router.push(`/admin/organizations/users/manage/${this.id}`);
        }

        invalidUpdateUserDetailsCommandV1(status) {
            this.$pushValidationErrors(status.ValidationErrors);
            this.setStatusInvalid();
        }

        failedUpdateUserDetailsCommandV1(status) {
            this.setStatusFailed();
        }
    }
</script>